import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCo_55wRxW10asZfP1VCa5kubDFpWaHNbk",
  authDomain: "padel-stats-eb496.firebaseapp.com",
  databaseURL: "https://padel-stats-eb496-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "padel-stats-eb496",
  storageBucket: "padel-stats-eb496.firebasestorage.app",
  messagingSenderId: "628034628901",
  appId: "1:628034628901:web:9b8393faf3b4572b387ecc"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export { database };
